<template>
  <BaseLoader :loader="loader" />

    <base-dialog :show="error != null" :showCloseIcon="false" title="Something Fishy" @close="error == null">
            <template v-slot:content>                  
                    <div class="inv-wrapper nwd-wrap">
                        <div class="inv-form-item">
                                <label>{{error}}</label>    
                        </div>
                    </div>
            </template>
                <template v-slot:actions>
                    <base-button class="app-icon large-btn" @click="error=null" title="Close">
                        <app-icon icon="hugeicons:cancel-square" width="18" />
                    </base-button>    
            </template>
  </base-dialog>


  <base-dialog :show="showDialog" :title="dialogAsset.FolderName" @close="closeDialog" :windowWidth="720">
        <template v-slot:content>                  
                <div class="inv-wrapper nwd-wrap">
                    <div class="view-item">
                            <label>{{dialogAsset.UserFileName}}</label>    
                            <img v-if="dialogAsset.Type === 'image'" :src="dialogAsset.Path" :alt="dialogAsset.UserFileName" />
                            <video autoplay loop muted v-else-if="dialogAsset.Type === 'video'" :src="dialogAsset.Path" :alt="dialogAsset.UserFileName" />
                    </div>
                </div>
        </template>
            <template v-slot:actions>
                <base-button class="app-icon large-btn" @click="closeDialog" title="Close">
                        <app-icon icon="hugeicons:cancel-square" width="18" />
                </base-button>                  
        </template>
  </base-dialog>



  <div class="admin-container">
    <NaviPanel />

    <main class="main-layout">
      <NaviHeader />

      <div class="content-scroll">

        <div class="cs-card">
            <h3>Assets</h3>
            <p class="text-tooltip">Manage assets used in campaigns.</p>
        </div>

        <!-- Formularz dodawania nowego assetu -->
        <div class="cs-card cs-animation add-asset-form">
          <h4>Add New Asset</h4>

          <div class="form-wrapper">

            <div class="form-row-flex">
                <div class="form-group">
                <label class="form-label">Format</label>
                <vue-select 
                    v-model="newAsset.FormatId" 
                    :options="formats" 
                    label-by="Name"
                    value-by="Id"
                    placeholder="Select format..."
                    clear-on-close 
                    close-on-select  
                />
                </div>

                <div class="form-group">
                <label class="form-label">Folder Name</label>
                <div class="folder-input-group">
                    <input 
                    v-if="showNewFolderInput"
                    v-model="newFolderName" 
                    type="text" 
                    class="form-input folder-input" 
                    placeholder="Enter new folder name..."
                    @blur="handleFolderInputBlur"
                    ref="newFolderNameInput"
                    />
                    <vue-select 
                    v-else
                    v-model="newAsset.FolderName" 
                    :options="folderNames" 
                    placeholder="Select folder..."
                    clear-on-close 
                    close-on-select
                    class="form-select-folder"  
                    />
                    <button 
                    @click="toggleNewFolderInput" 
                    class="app-icon folder-toggle-btn"
                    :title="showNewFolderInput ? 'Select existing' : 'Create new folder'"
                    >
                    <app-icon :icon="showNewFolderInput ? 'hugeicons:folder-search' : 'hugeicons:folder-add'" width="18" />
                    </button>
                </div>
                </div>

                <div class="form-group">
                <label class="form-label">Type</label>
                <vue-select 
                    v-model="newAsset.TypeId" 
                    :key="selectKey"
                    :options="fileTypes" 
                    label-by="Name"
                    value-by="TypeId"
                    placeholder="Select type..."
                    clear-on-close 
                    close-on-select  
                />
                </div>

            </div>

            <div class="form-row-flex">
                <div class="form-group file-input-group">
                <label class="form-label">File</label>
                <div class="file-input-wrapper">
                    <input 
                    type="file" 
                    ref="fileInput"
                    @change="handleFileSelect"
                    class="file-input"
                    :accept="fileAcceptTypes"
                    />
                    <button @click="triggerFileInput" class="file-select-btn">
                    <app-icon icon="hugeicons:file-upload" width="18" />
                    <span>{{ selectedFileName || 'Choose file...' }}</span>
                    </button>
                </div>
                </div>
            </div>
            <div class="form-row-flex">
                <div class="form-group">
                <button @click="addAsset" class="add-asset-btn app-icon">
                    <app-icon icon="hugeicons:cloud-upload" width="18" />
                    <span>Upload Asset</span>
                </button>
                </div>
            </div>
          </div>
        </div>

        <!-- Wyświetlanie assetów w strukturze folderów -->
        <div id="assets" class="cs-card cs-animation">
          <div class="asset-library-header">
            <h4>Asset Library</h4>
            <button
              v-if="Object.keys(groupedAssets).length > 0"
              class="app-icon toggle-all-btn"
              :title="allFoldersExpanded ? 'Collapse all' : 'Expand all'"
              @click="toggleAllFolders"
            >
              <app-icon :icon="allFoldersExpanded ? 'hugeicons:arrow-up-double' : 'hugeicons:arrow-down-double'" width="16" />
            </button>
          </div>
          
          <div v-if="Object.keys(groupedAssets).length === 0" class="empty-state">
            <app-icon icon="hugeicons:folder-open" width="48" />
            <p>No assets found. Upload your first asset above!</p>
          </div>

          <div v-else class="folder-tree">
            <div 
              v-for="(folderAssets, folderName) in groupedAssets" 
              :key="folderName"
              class="folder-item"
            >
              <div class="folder-header" @click="toggleFolder(folderName)">
                <app-icon 
                  :icon="expandedFolders[folderName] ? 'hugeicons:folder-open' : 'hugeicons:folder-02'" 
                  width="20" 
                />
                <span class="folder-name">{{ folderName }}</span>
                <span class="folder-count">({{ folderAssets.length }})</span>
                <app-icon 
                  :icon="expandedFolders[folderName] ? 'hugeicons:arrow-up-01' : 'hugeicons:arrow-down-01'" 
                  width="16" 
                  class="folder-toggle-icon"
                />
              </div>

              <transition name="folder-expand">
                <div v-show="expandedFolders[folderName]" class="folder-content">
                  <div 
                    v-for="asset in folderAssets" 
                    :key="asset.Id"
                    class="asset-item"
                  >
                    <div class="asset-preview">
                      <img 
                        v-if="asset.Type === 'image'" 
                        :src="asset.Path" 
                        :alt="asset.UserFileName"
                        @error="handleImageError"
                      />
                      <div v-else class="video-preview">
                        <app-icon icon="hugeicons:video-02" width="32" />
                      </div>
                    </div>
                    <div class="asset-info">
                      <div class="asset-name">{{ asset.UserFileName }}</div>
                      <div class="asset-meta">
                        <span class="asset-type-badge" :class="asset.Type">{{ asset.Type }}</span>
                        <span class="asset-format">{{ asset.FormatName }} ({{ asset.FormatWidth }}x{{ asset.FormatHeight }})</span>
                      </div>
                    </div>
                    <div class="asset-actions">
                      <button class="app-icon icon-blue" title="View" @click="assetBtnClick(asset.Id, 'view')">
                        <app-icon icon="hugeicons:view" width="18" />
                      </button>
                      <button class="app-icon" title="Delete" @click="assetBtnClick(asset.Id, 'delete')">
                        <app-icon icon="hugeicons:delete-03" width="18" />
                      </button>
                    </div>
                  </div>
                </div>
              </transition>
            </div>
          </div>
        </div>

      </div>
    </main>
  </div>
</template>


<script>
    import NaviPanel from '@/components/NaviPanel.vue';
    import NaviHeader from '@/components/NaviHeader.vue';
    import BaseLoader from '@/components/BaseLoader.vue';

    import shared from "@/shared";
    import apiService from "@/services/other.js";

    export default {
        components: { NaviPanel, NaviHeader, BaseLoader},
        name: 'AssetsView',

        data: function () {
            return { 
                loader: false,
                error: null,
                formats: [], 
                assets: [],
                fileTypes: [{TypeId: 1, Name: 'Image'}, {TypeId: 2, Name: 'Video'}],
                newAsset: {
                    FormatId: null,
                    FolderName: '',
                    TypeId: null,
                    File: null
                },
                newFolderName: '',
                showNewFolderInput: false,
                selectedFileName: '',
                expandedFolders: {},
                selectKey: 0,
                showDialog: false,
                dialogTitle: '',
                dialogAsset: {}
            };
        },

        computed: {
            allFoldersExpanded() {
                const folders = Object.keys(this.groupedAssets);
                if (folders.length === 0) return false;
                return folders.every(f => this.expandedFolders[f] === true);
            },

            // Grupowanie assetów według folderów
            groupedAssets() {
                if (!this.assets || !Array.isArray(this.assets)) {
                    return {};
                }
                const grouped = {};
                this.assets.forEach(asset => {
                    const folder = asset.FolderName || 'Uncategorized';
                    if (!grouped[folder]) {
                        grouped[folder] = [];
                    }
                    grouped[folder].push(asset);
                });
                return grouped;
            },

            // Lista unikalnych nazw folderów
            folderNames() {
                if (!this.assets || !Array.isArray(this.assets)) {
                    return [];
                }
                const folders = [...new Set(this.assets.map(a => a.FolderName).filter(f => f))];
                return folders;
            },

            // Akceptowane typy plików na podstawie wybranego typu
            fileAcceptTypes() {
                if (this.newAsset.Type === 'image') {
                    return 'image/*';
                } else if (this.newAsset.Type === 'video') {
                    return 'video/*';
                }
                return '*/*';
            },

            getSelectedFormat() {
                return this.formats.find(f => f.Id === this.newAsset.FormatId) || null;
            }
        },

        created() {                     
        },

        mounted() {
            this.assetsList();
            this.formatList();
        },

        methods: {   
            
            formatList() {
                const data = {ResultName: "bannerList"};
                apiService
                    .uniExec(data)
                    .then((response) => {
                        if (response.status === 200) {                  
                            this.formats = response.data;  
                            this.selectKey++;
                            console.log(this.formats);
                        }
                    })
                    .catch((e) => shared.handleError.call(this, '402', true, e));
            },

            assetsList() {
            
                const data = {ResultName: "assetsList"};
                apiService
                    .uniExec(data)
                    .then((response) => {
                    if (response.status === 200) {                  
                            
                            this.assets = response.data;  
                            console.log(this.assets);
                    }
                    })
                    .catch((e) => shared.handleError.call(this, '403', true, e));
            },

            toggleFolder(folderName) {
                this.expandedFolders[folderName] = !this.expandedFolders[folderName];
            },

            toggleAllFolders() {
                const folders = Object.keys(this.groupedAssets);
                const shouldCollapse = this.allFoldersExpanded;
                folders.forEach(folder => {
                    this.expandedFolders[folder] = !shouldCollapse;
                });
                // Wymuś reaktywność
                this.expandedFolders = { ...this.expandedFolders };
            },

            toggleNewFolderInput() {
                this.showNewFolderInput = !this.showNewFolderInput;

                if (this.showNewFolderInput) {
                    this.newAsset.FolderName = '';
                    this.$nextTick(() => {
                        const input = this.$refs.newFolderNameInput;
                        if (input) input.focus();
                    });
                } else {
                    this.newFolderName = '';
                }
            },

            handleFolderInputBlur() {
                if (this.newFolderName.trim()) {
                    this.newAsset.FolderName = this.newFolderName.trim();
                }
            },

            triggerFileInput() {
                this.$refs.fileInput.click();
            },

            handleFileSelect(event) {
                const file = event.target.files[0];
                if (file) {
                    this.newAsset.File = file;
                    this.selectedFileName = file.name;
                }
            },

            async addAsset() {
                // Walidacja
                if (!this.newAsset.FormatId) {
                    alert('Please select a format');
                    return;
                }
                if (!this.newAsset.FolderName && !this.newFolderName) {
                    alert('Please select or create a folder');
                    return;
                }
                if (!this.newAsset.TypeId) {
                    alert('Please select a file type');
                    return;
                }
                if (!this.newAsset.File) {
                    alert('Please select a file');
                    return;
                }

                const format = this.getSelectedFormat;
                if (!format) {
                    alert('Selected format not found');
                    return;
                }

                try {
                    // 🔍 WALIDACJA ROZDZIELCZOŚCI
                    await this.validateFileResolution(
                        this.newAsset.File,
                        format.Width,
                        format.Height
                    );
                } catch (errorMessage) {
                    alert(errorMessage);
                    return; // ⛔ blokujemy upload
                }

                // Użyj nowej nazwy folderu jeśli została wprowadzona
                const folderName = this.newFolderName.trim() || this.newAsset.FolderName;

                console.log('Adding new asset:', {
                    FormatId: this.newAsset.FormatId,
                    FolderName: folderName,
                    TypeId: this.newAsset.TypeId,
                    File: this.newAsset.File,
                    FileName: this.newAsset.File.name
                });

                // Tutaj dodasz metodę do wysyłania do API
                const formData = new FormData();
                formData.append('file', this.newAsset.File);
                formData.append('FormatId', this.newAsset.FormatId);
                formData.append('FolderName', folderName);
                formData.append('TypeId', this.newAsset.TypeId);
                
                this.loader = true;
                apiService.uploadAsset(formData)
                  .then(response => {
                    console.log(response);
                    this.resetForm();
                    this.assetsList();
                  })
                  .catch((e) => shared.handleError.call(this, '401', true, e))
                  .finally(() => {
                    this.loader = false;
                  });
            },

            resetForm() {
                this.newAsset = {
                    FormatId: null,
                    FolderName: '',
                    TypeId: null,
                    File: null
                };
                this.newFolderName = '';
                this.showNewFolderInput = false;
                this.selectedFileName = '';
                if (this.$refs.fileInput) {
                    this.$refs.fileInput.value = '';
                }
            },

            handleImageError(event) {
                event.target.src = 'data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="100" height="100"><text x="50%" y="50%" text-anchor="middle" dy=".3em">No Image</text></svg>';
            },

            validateFileResolution(file, expectedWidth, expectedHeight) {
                return new Promise((resolve, reject) => {

                    // IMAGE
                    if (file.type.startsWith('image/')) {
                        const img = new Image();
                        const url = URL.createObjectURL(file);

                        img.onload = () => {
                            URL.revokeObjectURL(url);

                            if (img.width === expectedWidth && img.height === expectedHeight) {
                                resolve(true);
                            } else {
                                reject(`Image must be exactly ${expectedWidth}x${expectedHeight}px`);
                            }
                        };

                        img.onerror = () => {
                            URL.revokeObjectURL(url);
                            reject('Invalid image file');
                        };

                        img.src = url;
                    }

                    // VIDEO
                    else if (file.type.startsWith('video/')) {
                        const video = document.createElement('video');
                        const url = URL.createObjectURL(file);

                        video.preload = 'metadata';
                        video.onloadedmetadata = () => {
                            URL.revokeObjectURL(url);

                            if (
                                video.videoWidth === expectedWidth &&
                                video.videoHeight === expectedHeight
                            ) {
                                resolve(true);
                            } else {
                                reject(`Video must be exactly ${expectedWidth}x${expectedHeight}px`);
                            }
                        };

                        video.onerror = () => {
                            URL.revokeObjectURL(url);
                            reject('Invalid video file');
                        };

                        video.src = url;
                    }

                    else {
                        reject('Unsupported file type');
                    }
                });
            },

            assetBtnClick(id, mode) {
                
                if (mode === 'delete') {
                    this.deleteAsset(id);
                }
                else if (mode === 'view') {
                    this.viewAsset(id);
                }
            },

            deleteAsset(id) {
                apiService.deleteAsset(id)
                    .then(response => {
                        if (response.status === 200) {                            
                            this.assetsList();
                        }
                    })
                    .catch((e) => shared.handleError.call(this, '405', true, e));
            },

            viewAsset(id) {
                this.dialogAsset = this.assets.find(a => a.Id === id);
                this.showDialog = true;
            },

            closeDialog() {
                this.showDialog = false;
                this.dialogAsset = {};
            },


        },

        watch: {
            groupedAssets: {
                handler(newVal) {
                    // Automatycznie rozwiń nowe foldery
                    Object.keys(newVal).forEach(folder => {
                        if (!(folder in this.expandedFolders)) {
                            this.expandedFolders[folder] = true;
                        }
                    });
                },
                deep: true
            }
        },

        
    }
</script>



<style scoped>

/* Formularz dodawania */
.add-asset-form {
  margin-bottom: 20px;
}

.add-asset-form h4 {
  margin-bottom: 15px;
  color: var(--text-main);
}

/* .form-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 15px;
  align-items: end;
} */

.form-group {
  display: flex;
  flex-direction: column;
}

.form-label {
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 5px;
  color: var(--text-theader);
}

.form-input {
  padding: 8px 12px;
  border: 1px solid var(--border);
  border-radius: 6px;
  font-size: 12px;
  background: var(--bg-page);
  color: var(--text-theader);
}

.form-input.folder-input {
    padding: 6px 12px;
}

.folder-input-group {
  display: flex;
  gap: 8px;
  align-items: center;
}

.vue-select.form-select-folder {
    width: 192px;
}


.file-input-group {
  /* grid-column: 1 / -1; */
  flex: 1;
}

.file-input-wrapper {
  position: relative;
}

.file-input {
  display: none;
}

.file-select-btn {
  width: 100%;
  padding: 8px 12px;
  border: 1px dashed var(--border);
  border-radius: 6px;
  background: var(--bg-page);
  color: var(--text-theader);
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: all 0.3s ease;
}

.file-select-btn:hover {
  border-color: var(--primary);
  background: rgba(var(--primary-rgb), 0.05);
}

.add-asset-btn {
  width: 100%;
  padding: 10px 16px;
  background: var(--blue);
  color: white;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  transition: all 0.3s ease;
}

.add-asset-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
  background: var(--blue-dark);
}

/* Drzewo folderów */
.asset-library-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
}

.asset-library-header h4 {
  margin: 0;
  color: var(--text-main);
}

.toggle-all-btn {
  padding: 5px 8px;
  border-radius: 6px;
  background: transparent;
  border: 1px solid var(--border);
  color: var(--text-muted);
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
}

.toggle-all-btn:hover {
  border-color: var(--blue);
  color: var(--blue);
  background: rgba(var(--primary-rgb), 0.05);
}

.empty-state {
  text-align: center;
  padding: 40px;
  color: var(--text-muted);
}

.empty-state svg {
  margin-bottom: 15px;
  opacity: 0.3;
}

.folder-tree {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.folder-item {
  border: 1px solid var(--border);
  border-radius: 8px;
  overflow: hidden;
  background: var(--bg-page);
  transition: all 0.3s ease;
}

.folder-item:hover {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.folder-header {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 15px;
  background: linear-gradient(135deg, rgba(102, 126, 234, 0.1) 0%, var(--bg-page) 100%);
  cursor: pointer;
  user-select: none;
  transition: background 0.3s ease;
}

.folder-header:hover {
  background: linear-gradient(135deg, rgba(102, 126, 234, 0.15) 0%, rgba(118, 75, 162, 0.15) 100%);
}

.folder-name {
  font-size: 16px;
  font-weight: 600;
  color: var(--text-theader);
  flex-grow: 1;
}

.folder-count {
  font-size: 14px;
  color: var(--text-muted);
}

.folder-toggle-icon {
  transition: transform 0.3s ease;
}

.folder-content {
  padding: 15px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

/* Animacja rozwijania folderu */
.folder-expand-enter-active, .folder-expand-leave-active {
  transition: all 0.3s ease;
  max-height: 1000px;
  overflow: hidden;
}

.folder-expand-enter, .folder-expand-leave-to {
  max-height: 0;
  opacity: 0;
}

/* Asset item */
.asset-item {
  display: flex;
  align-items: center;
  gap: 15px;
  padding: 10px;
  border: 1px solid var(--border);
  border-radius: 6px;
  background: var(--bg-page);
  transition: all 0.3s ease;
}

.asset-item:hover {
  border-color: var(--blue);
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
  transform: translateX(3px);
}

.asset-preview {
  width: 70px;
  height: 70px;
  flex-shrink: 0;
  border-radius: 6px;
  overflow: hidden;
  background: #f5f5f5;
  display: flex;
  align-items: center;
  justify-content: center;
}

.asset-preview img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.video-preview {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--text-muted);
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
}

.asset-info {
  flex-grow: 1;
}

.asset-name {
  font-size: 14px;
  font-weight: 600;
  color: var(--text-theader);
  margin-bottom: 5px;
}

.asset-meta {
  display: flex;
  gap: 10px;
  align-items: center;
}

.asset-type-badge {
  font-size: 11px;
  padding: 2px 8px;
  border-radius: 12px;
  font-weight: 600;
  text-transform: uppercase;
}

.asset-type-badge.image {
  background: rgba(102, 126, 234, 0.2);
  color: var(--blue);
}

.asset-type-badge.video {
  background: rgba(118, 75, 162, 0.2);
  color: var(--purple);
}

.asset-format {
  font-size: 12px;
  color: var(--text-muted);
}

.asset-actions {
  display: flex;
  /* gap: 8px; */
}

.asset-actions button {
  padding: 3px 5px;
}

.view-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;
    padding: 10px;
    border: 1px solid var(--border);
    border-radius: 6px;
    background: var(--bg-page);
    transition: all 0.3s ease;
}

.view-item:hover {
    border-color: var(--text-muted);
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
    transform: translateX(3px);
}

.view-item img,
.view-item video {
    max-height: 490px;
    max-width: 640px;
}

.view-item label {
    font-size: 12px;
    color: var(--text-theader);
    margin-bottom: 5px;
}


</style>
